<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
        class="hidden-xs"
        :background="background"
        :page-size="pageSize"
        :current-page="pageNum"
        :total="total"
        :layout="layout"
        @current-change="handleCurrentChange"
    />
    <el-pagination
        small
        class="visible-xs-block"
        layout="prev, pager,next"
        :page-size="pageSize"
        :current-page="pageNum"
        :total="total"
        @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    pageNum: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 24
    },
    layout: {
      type: String,
      // default: 'total, sizes, prev, pager, next, jumper'
      default: 'total,  prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCurrentChange(val) {
      // this.$emit('pagination', {page: val, limit: this.pageSize})
      this.$emit('pagination', val)
      if (this.autoScroll) {
        this.scrollTop();
      }
    },
    //跳到页顶
    scrollTop(selector) {
      let element = selector && document.querySelector(selector) || window;
      element.scrollTo(0, 0);
    },
  }
}
</script>

<style lang="scss">
.pagination-container {
  background-color: --color(--p-white);
  padding: 20px 0;
  text-align: center;
}

.pagination-container.hidden {
  display: none;
}
</style>
